import { IconContext } from "react-icons";
import { IoMdArrowBack } from 'react-icons/io';
import { AiFillCloseCircle, AiFillCheckCircle } from 'react-icons/ai';

import style from './BackCard.module.scss';
import Botao from 'componentes/Botao';


const BackCard = ({ clique, nome, idade, bairro, dataDesaparecimento, detalhes, contato }) => {
  return (
    <div className={style.post}>

      <div className={style.titulo}>
        <h2>Nome: {nome}</h2>
      </div>

      <div className={style.descricao}>
        <p><span>Idade: </span>{idade}</p>        
        <p><span>Bairro: </span>{bairro}</p>
        <p><span>Desaparecido: </span>{dataDesaparecimento}</p>
        <p><span>Detalhes: </span>{detalhes}</p>
        <p><span>Contato: </span>{contato}</p>
        <p className={style.recompensa}>Recompensa?
          <span>
            <IconContext.Provider
            value={{ color: 'green', size: '18px' }}
            >
              <AiFillCheckCircle  />
            </IconContext.Provider>

            <IconContext.Provider
            value={{ color: 'red', size: '18px' }}
            >
              <AiFillCloseCircle />
            </IconContext.Provider>            
          </span>
        </p>

      </div>

      <div>
        <Botao className={style.botao} cliqueBotao={clique}><IoMdArrowBack />Voltar</Botao>
      </div>
    </div>

  )
}

export default BackCard;